import { useTranslation } from "react-i18next";
import Field from "../../../../../../components/shared/Form/Field";
import Checkbox from "../../../../../../components/shared/inputs/Checkbox";
import type { ConfigItem } from "./config";

function Content({ name, title, items }: { name: string, title: string, items: ConfigItem[] }) {
    const { t } = useTranslation();

    return (
        <div className="tw-mb-6 tw-w-52 tw-self-start">
            <h3 className="tw-font-semibold tw-text-xs tw-px-1 tw-mb-1 tw-text-foreground">
                {t(title)}
            </h3>

            {items.map((item) => (
                <div
                    key={item.key}
                    className="tw-flex tw-justify-between tw-items-center tw-py-1 tw-px-1"
                >
                    <span className="tw-text-sm tw-text-muted-foreground">{item.name}</span>

                    <Field
                        name={`${name}.${item.key}`}
                        valuePropName="checked"
                        className="tw-mb-0"
                    >
                        <Checkbox />
                    </Field>
                </div>
            ))}
        </div>
    );
}

export default Content;
